import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BadgeModule } from 'primeng/badge';
import { ProgressBarModule } from 'primeng/progressbar';

@Component({
  selector: 'app-info-bargraph',
  standalone: true,
  imports: [CommonModule, ProgressBarModule, BadgeModule],
  templateUrl: './info-bargraph.component.html',
  styleUrl: './info-bargraph.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoBargraphComponent {
  private _percentage = 0;

  @Input()
  set percentage(value: number) {
    const num = Number(value);
    this._percentage = isNaN(num) ? 0 : Math.min(100, Math.ceil(num));
  }
  get percentage(): number {
    return this._percentage;
  }
  @Input() subText!: string;
  @Input() badgeText?: string = undefined;
}
